import { initializeLibraryDocsPlugin } from './LibraryDocsPlugin';
import { createFileLogger } from '../../../utils/logger';

const log = createFileLogger('LIBRARY_PLUGIN_INIT');

/**
 * Initialize Library plugin integration with other apps
 * Call this once at app startup, before any editors are created
 */
export function initializeLibraryPlugin() {
  try {
    // Initialize Docs integration (schema extensions, hotkeys)
    initializeLibraryDocsPlugin();
    
    log.info('[LibraryPlugin] Plugin initialized successfully');
  } catch (error) {
    log.error('[LibraryPlugin] Failed to initialize plugin:', error);
  }
}

// Auto-initialize on import
if (!(globalThis as any).__LIBRARY_PLUGIN_INITIALIZED__) {
  initializeLibraryPlugin();
  (globalThis as any).__LIBRARY_PLUGIN_INITIALIZED__ = true;
}


